// extracted by mini-css-extract-plugin
export default {"card":"edit_card__Js1l4","icon":"edit_icon__1644P","text":"edit_text__KaWUU"};